export interface TooltipEmployeeInfo {
  'prestations': {id: string, name: string, value: number}[],
  'hours': number,
  'hoursNight': number,
  'hoursWeekEnd': number,
  'hoursLeave': number
}
